export default __webpack_public_path__ + "static/media/girl-1.c6952868.png";